import { useState } from "react";
import {
  AlertDialog,
  AlertDialogProps,
  Button,
  Divider,
  MUITypography,
} from "@cobee/cobee-ui";
import { useTranslation } from "react-i18next";
import { CustomTextField, styles } from "./styles";
import useRejectBenefitRequest from "../../hooks/mutations/useRejectBenefitRequest";

export default function RejectRequestDialog({
  requestId,
  companyId,
  benefit,
  dialogProps,
  closeDialog,
}: {
  requestId: string;
  companyId: string;
  benefit: string;
  dialogProps: AlertDialogProps;
  closeDialog: any;
}) {
  const [reason, setReason] = useState<string>("");
  const { t } = useTranslation();
  const { titleStyle } = styles;

  const rejectMutation = useRejectBenefitRequest();

  return (
    <AlertDialog
      hookProps={dialogProps}
      maxWidth="xs"
      title={t("v2.benefit-requests.request-denied")}
    >
      <MUITypography variant="body2" sx={titleStyle}>
        {t("v2.benefit-requests.you-are-rejecting-this-request-for-benefit", {
          benefitName: t(`v2.common.benefit-type.${benefit}`),
        })}
      </MUITypography>
      <MUITypography variant="body1">
        {t(
          "v2.benefit-requests.optional-message-provide-more-details-for-rejection"
        )}
      </MUITypography>
      <CustomTextField onBlur={(e) => setReason(e.target.value)} />
      <Button
        variant="outlined"
        color="secondary"
        loading={rejectMutation.isLoading}
        onClick={() =>
          rejectMutation.mutate(
            { companyId, requestId, reason },
            {
              onSuccess: () => {
                closeDialog();
              },
            }
          )
        }
      >
        {t("v2.common.accept")}
      </Button>
      <Divider margin={25} />
      <MUITypography variant="body2">
        {t(
          "v2.benefit-requests.this-employee-will-be-notified-rejected-request-via-email"
        )}
      </MUITypography>
    </AlertDialog>
  );
}
